<template>
  <div class="tax-query-container">
    <van-nav-bar
      title="个人所得税查询"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="form-container">
      <van-form @submit="onSubmit">
        <van-field
          v-model="formData.name"
          name="name"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="formData.idCard"
          name="idCard"
          label="身份证号码"
          placeholder="请输入身份证号码"
          :rules="[
            { required: true, message: '请填写身份证号码' },
            { validator: validateIdCard, message: '请输入正确的身份证号码' }
          ]"
        />
        <van-field
          v-model="formData.year"
          name="year"
          label="查询年度"
          readonly
          is-link
          @click="showYearPicker = true"
          placeholder="请选择查询年度"
          :rules="[{ required: true, message: '请选择查询年度' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit">
            查询
          </van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showYearPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="yearColumns"
        @confirm="onYearConfirm"
        @cancel="showYearPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'TaxQuery',
  data () {
    return {
      formData: {
        name: '',
        idCard: '',
        year: ''
      },
      showYearPicker: false,
      yearColumns: this.generateYearColumns()
    }
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    onSubmit (values) {
      // 表单提交，跳转到结果页面
      this.$router.push({
        path: '/taxQueryResult',
        query: {
          name: this.formData.name,
          idCard: this.formData.idCard,
          year: this.formData.year
        }
      })
    },
    validateIdCard (val) {
      // 简单的身份证号码验证
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return reg.test(val)
    },
    onYearConfirm (value) {
      this.formData.year = value
      this.showYearPicker = false
    },
    generateYearColumns () {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = 0; i < 5; i++) {
        years.push(`${currentYear - i}年`)
      }
      return years
    }
  }
}
</script>

<style scoped>
.tax-query-container {
  height: 100vh;
  background-color: #f7f8fa;
}
.form-container {
  padding: 20px;
  background-color: #fff;
  margin-top: 12px;
}
</style>